// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__11zOs","title":"AfterImages45_title__vvIMg","images":"AfterImages45_images__2vT_s"};